<template>
  <div class="Index">
    <!-- 轮播图开始 -->
    <el-carousel :interval="4000" arrow="never" height="620px">
      <el-carousel-item>
        <img class="carouse-img-one" src="../assets/Main/banner-1.png" alt="First slide">
        <div class="sol-content-detail">
          <h1>印点点自助打印</h1>
          <p>自助打印系统方案商</p>
          <p>针对不同场景，不同人群，提供多款自助打印系统</p>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <img class="carouse-img-one" src="../assets/Main/banner-2.png" alt="Second slide">
        <div class="sol-content-detail">
          <h1 data-delighter>自助打印机解决方案</h1>
          <p data-delighter>借助印点点自助打印系统，将传统打印机升级为自助打印机，</p>
          <p data-delighter>投放到图文店、便利店、社区等场所，</p>
          <p data-delighter>面向用户提供自助打印、自助洗相、自助证件照来实现盈利。</p>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <img class="carouse-img-one" src="../assets/Main/banner-3.png" alt="Third slide">
        <div class="sol-content-detail" >
          <h1 data-delighter style="color: #0B184D;">自助复印机解决方案</h1>
          <p data-delighter style="color: #000C42;">借助复印机自助打印软件，将传统复印机升级为自助复印机，</p>
          <p data-delighter style="color: #000C42;">投放到高校、培训机构、政务大厅等场所，</p>
          <p data-delighter style="color: #000C42;">面向用户提供自助打印、自助复印、自助扫描来实现盈利。</p>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 登录界面 -->
    <!-- content开始 -->
    <div class="content-bg-box">
      <div class="container">
        <div class="row content-one-title">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <h1>自助打印服务商</h1>
            <p style="margin: 30px 0;">印点点自助打印是一家专注于文印创新体验的科技公司，采用云打印的方式，使普通打印机具备自助打印文档、照片、证件照功能，普通复印机实现自助打印、自助复印、自助扫描功能，用户可以通过电脑、手机等终端操作打印，为用户带来更便捷的打印体验。</p>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="card-deck">
              <div class="card card-kind">
                <img class="card-img-top card-img" src="../assets/Main/img-1.png" style="width: 120px;height: 120px;" alt="多人群">
                <div class="card-body">
                  <h5 class="card-title">多人群</h5>
                  <p class="card-text">印点点自助打印，面向个体店主、自助打印投放商、共享经济运营商等群体，提供不同产品服务支持。</p>
                </div>
              </div>
              <div class="card card-kind">
                <img class="card-img-top card-img" src="../assets/Main/img-2.png" style="width: 120px;height: 120px;" alt="多场景">
                <div class="card-body">
                  <h5 class="card-title">多场景</h5>
                  <p class="card-text">印点点自助打印系统，针对图文店、高校、快递驿站、政务大厅、连锁酒店，企业办公等场景均有解决方案。</p>
                </div>
              </div>
              <div class="card card-kind">
                <img class="card-img-top card-img" src="../assets/Main/img-3.png" style="width: 120px;height: 120px;" alt="多格式">
                <div class="card-body">
                  <h5 class="card-title">多形式</h5>
                  <p class="card-text">印点点自助打印系统支持多格式文件打印、图片打印、照片打印、证件照制作。</p>
                </div>
              </div>
              <div class="card card-kind">
                <img class="card-img-top card-img" src="../assets/Main/img-4.png" style="width: 120px;height: 120px;" alt="多入口">
                <div class="card-body">
                  <h5 class="card-title">多入口</h5>
                  <p class="card-text">支持微信端、QQ端、PC电脑端、平板、驱动多入口打印。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" style="padding-bottom: 0px;">
      <div class="row content-one-title" style="padding-bottom: 0px;">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <h1>多款自助打印系统</h1>
          <p style="margin: 30px 0;">公司自研多款打印软件，供不同场景使用</p>
        </div>
      </div>
      <!-- 软件分类导航 -->
      <div class="software-nav">
        <div class="nav-tabs">
          <div v-for="(software, index) in softwareList" :key="index" class="nav-item" :class="{ active: activeTab === index }" @click="switchTab(index)">
            {{ software.title }}
          </div>
        </div>
      </div>

    </div>

    <div style="background-color: #F1F9FF;">
      <div class="container" style="padding:20px 0;"> <!-- 软件卡片内容 -->
        <div class="software-content">
          <div class="row">
            <div class="col-md-6">
              <div class="software-illustration">
                <img :src="currentSoftware.img" :alt="currentSoftware.title" class="software-img">
              </div>
            </div>
            <div class="col-md-6">
              <div class="software-details">
                <h2>{{ currentSoftware.title }}</h2>
                <div class="feature-item">
                  <span class="label">系统特点：</span><span class="content">{{ currentSoftware.features }}</span>
                </div>
                <div class="scenario-item">
                  <span class="label">{{ currentSoftware.scenarioLabel }}：</span><span class="content">{{ currentSoftware.scenario }}</span>
                </div>
                <el-button  round plain type="primary" @click="$router.push(currentSoftware.url)">查看详情</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 多场景解决方案 -->
    <div class="container">
      <div class="row content-one-title">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <h1>多场景解决方案</h1>
          <p style="margin: 30px 0;">印点点自助打印针对图文快印店、高校、共享经济、图书馆、企业共享办公等场景都有成熟的解决方案</p>
        </div>
      </div>
      
      <!-- 解决方案卡片区域 -->
      <div class="solutions-container">
        <div 
          v-for="(solution, index) in solutionList" 
          :key="index" 
          class="solution-card"
          :class="{ 'active': activeSolution === index }"
          @mouseenter="switchSolution(index)"
        >
          <div class="solution-image">
            <img :src="activeSolution === index ? solution.activeBg : solution.bg" :alt="solution.title">
          </div>
          <div class="solution-content">
            <h3>{{ solution.title }}</h3>
            <p v-if="activeSolution === index" class="solution-subtitle">{{ solution.subtitle }}</p>
            <p v-if="activeSolution === index" class="solution-description">{{ solution.description }}</p>
            <!-- <el-button 
              v-if="activeSolution === index" 
              round 
              plain 
              type="primary" 
              class="solution-btn"
              @click.stop="$router.push(solution.url)"
            >
              查看详情
            </el-button> -->
          </div>
        </div>
      </div>
    </div>

    <div class="content-last" style="background-color: #F1F9FF;">
      <div class="container">
        <div class="row content-one-title">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <h1>精细化场景应用展示</h1>
            <p style="margin: 30px 0;">我们的用户遍布互联网、高校、共享经济、企业、众创空间、图文店等众多领域。 </p>
          </div>
          <div class="card-deck">
            <div class="card text-white">
              <img class="card-img content-last-img" src="../assets/1.png" alt="Card image">
            </div>
            <div class="card text-white">
              <img class="card-img content-last-img" src="../assets/2.png" alt="Card image">
            </div>
            <div class="card text-white">
              <img class="card-img content-last-img" src="../assets/3.png" alt="Card image">
            </div>
            <div class="card text-white">
              <img class="card-img content-last-img" src="../assets/4.png" alt="Card image">
            </div>
          </div>
          <div class="card-deck">
            <div class="card text-white">
              <img class="card-img content-last-img" src="../assets/5.png" alt="Card image">
            </div>
            <div class="card text-white">
              <img class="card-img content-last-img" src="../assets/6.png" alt="Card image">
            </div>
            <div class="card text-white">
              <img class="card-img content-last-img" src="../assets/7.png" alt="Card image">
            </div>
            <div class="card text-white">
              <img class="card-img content-last-img" src="../assets/8.png" alt="Card image">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container partners">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <h1>合作伙伴</h1>
          <h2>加入印点点，开创新业务，获取技术，资源，实现更快成长</h2>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 partners-icon">
          <img src="../assets/Partners1.png" alt="" />
          <img src="../assets/Partners8.png" alt="" />
          <img src="../assets/Partners2.png" alt="" />
          <img src="../assets/Partners3.png" alt="" />
          <img src="../assets/Partners4.png" alt="" />
          <img src="../assets/Partners5.png" alt="" />
          <img src="../assets/Partners6.png" alt="" />
          <img src="../assets/Partners7.png" alt="" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      activeTab: 0,
      softwareList: [
        {
          title: "自助打印系统",
          img: require("../assets/Main/img2-1.png"),
          features: "微信扫码打印，支持OEM，DIY自己专属的打印品牌",
          scenarioLabel: "适合群体",
          scenario: "自助打印投放、自助打印加盟、自助打印招商等（找项目）；",
          url: "/SelfPrinting"
        },
        {
          title: "图文店自助打印系统",
          img: require("../assets/Main/img2-2.png"),
          features: "支持电脑自助打印，手机自助打印",
          scenarioLabel: "适合场景",
          scenario: "图文店、广告店、文印社等（省人工，降本增效）；",
          url: "/PrintSolution"
        },
        {
          title: "复印机自助打印系统",
          img: require("../assets/Main/img2-3.png"),
          features: "无需电脑，无需盒子，让普通复印机变身自助复印机，配置更高",
          scenarioLabel: "适合场景",
          scenario: "高校、政务大厅等（做投放）；",
          url: "/CopierSelfprinting"
        },
        {
          title: "共享打印系统",
          img: require("../assets/Main/img2-4.png"),
          features: "无需电脑，无需盒子，30s让普通打印机变身共享打印机，极致成本",
          scenarioLabel: "适合群体",
          scenario: "个体店主、连锁酒店、快递驿站等大型企业增收引流（连锁运营）",
          url: "/SharePrinting"
        }
      ],
      activeSolution: 0, // 默认突出第一个解决方案
      solutionList: [
      {
        title: "社区自助打印机解决方案",
        subtitle: "自助打印/自助洗相/自助证件照",
        description: "借助印点点自助打印系统，将传统打印机升级为自助打印机，投放到便利店、文具店、自习室等场所，面向用户提供自助打印、自助洗相、自助证件照来实现盈利；",
        bg: require("../assets/Main/solution-1.png"),
        activeBg: require("../assets/Main/solution-y-1.png"),
        url: "/SelfPrinting"
      },
        {
          title: "图文快印店解决方案",
          subtitle: "QQ/微信扫码付费打印",
          description: "为图文店、广告店店主提供的自助打印软件服务，帮助客户拉近用户距离，高效率、低成本提升服务体验；",
          bg: require("../assets/Main/solution-2.png"),
          activeBg: require("../assets/Main/solution-y-2.png"),
          url: "/PrintSolution"
        },
        {
          title: "高校自助复印机解决方案",
          subtitle: "自助打印/自助复印/自助扫描",
          description: "借助复印机自助打印软件，将传统复印机升级为自助复印机，投放到高校、法院等场所，面向用户提供自助打印、自助复印、自助扫描服务来实现盈利；",
          bg: require("../assets/Main/solution-3.png"),
          activeBg: require("../assets/Main/solution-y-3.png"),
          url: "/CopierSelfprinting"
        },
        {
          title: "企业共享办公解决方案",
          subtitle: "外部打印收费、内部打印免费",
          description: "将传统复印机升级为共享办公复印机，外部人员扫码付费打印，支持自助打印/复印/扫描；内部员工打印自动按部门做统计和费用归结；",
          bg: require("../assets/Main/solution-4.png"),
          activeBg: require("../assets/Main/solution-y-4.png"),
          url: "/ShareSolution"
        }
      ]
    };
  },
  computed: {
    currentSoftware() {
      return this.softwareList[this.activeTab];
    },
  },
  methods: {
    switchTab(index) {
      this.activeTab = index;
    },
    switchSolution(index) {
      this.activeSolution = index;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="less" scoped>
.sol-content-detail {
  position: absolute;
  top: 50%;
  left: 15%;
  transform: translateY(-50%);
  width: 60%;
  z-index: 5;

  h1 {
    font-size: 2.8rem;
    font-weight: 600;
    line-height: 1.3;
    color: #fff;
    margin-bottom: 20px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  p {
    color: #fff;
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 15px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }
}

.card-img {
  width: 140px;
  height: 120px;
  margin: 0 auto;
  transition: width 1s linear 2s;
}

.t-text,
.tt-text {
  position: absolute;
  right: 25%;
  text-align: right;

  h1,
  h3,
  p {
    color: #18182a;
  }

  h1 {
    font-size: 42px;
  }

  h3 {
    margin: 30px 0 8px;
  }

  p {
    font-size: 25px;
  }

  .c-btn {
    width: 120px;
  }
}

.t-text {
  top: 12%;

  .c-btn {
    margin-top: 38px;
  }
}

.tt-text {
  top: 18%;

  .c-btn {
    margin-top: 45px;
  }

  .icon-code {
    .icon-number {
      width: 160px;
      height: 160px;
      margin-top: 25px;
    }

    .icon-number-tip {
      font-size: 16px;
      color: #2a2c2d;
      margin-top: 10px;
    }
  }
}

.icon {
  width: 90px;
  height: 90px;
}

.clear {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

// 多场景解决方案
.card-over {
  padding: 8rem 2rem !important;

  .line {
    width: 40px;
    height: 2px;
    margin: 30px auto;
    background-color: #fff;
  }

  p,
  .btn {
    opacity: 0;
  }
}

// 多场景解决方案鼠标移动效果
.clear:hover {
  position: relative;

  .card-over {
    padding: 2.25rem !important;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .mask {
    width: 300px;
    height: 480px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(24, 121, 240, 0.6);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .line {
    display: none;
  }

  p,
  .btn {
    opacity: 1;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  h5 {
    margin-top: 10px;
  }

  p {
    margin: 20px 0 50px;
  }
}

.carouse-img-one {
  width: 100%;
  height: 620px;
  object-fit: cover;
  display: block;
}

.carouse-img-two {
  width: 100%;
  height: 520px;
  object-fit: cover;
  display: block;
}
.container {
  padding: 100px 0;
}

.content-one-title {
  text-align: center;
  padding: 50px 0;
  display: flex;
  justify-content: center;
}

.content-last {
  position: relative;
}

.content-last-img {
  width: 275px;
  height: 250px;
}

.card-kind {
  padding: 20px 0;
  background-color: #f6fbff;
  border: 4px solid #ffffff;
}

.card-kind:hover {
  h5 {
    color: #30bbfc;
    transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  }
}
.card-kind .card-body .card-text {
  text-align: left;
}

.card-deck .card {
  margin-bottom: 15px !important;
}

.content-bg-box {
  background: url(../assets/Main/content-bg.png) no-repeat center center;
}

/* 软件展示区域样式 */
.software-nav {
  margin: 40px 0;
}

.nav-tabs {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #e0e0e0;
}

.nav-item {
  padding: 15px 30px;
  margin: 0 10px;
  cursor: pointer;
  color: #666;
  font-size: 16px;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
}

.nav-item:hover {
  color: #30bbfc;
}

.nav-item.active {
  color: #30bbfc;
  border-bottom-color: #30bbfc;
}

.software-content {
  margin: 40px 0;
}

.software-illustration {
  text-align: center;
  padding: 20px;
}

.software-img {
  max-width: 100%;
  height: auto;
}

.software-details {
  padding: 80px 20px 20px;
}

.software-details h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 30px;
  font-weight: 600;
}

.feature-item,
.scenario-item {
  margin: 20px 0;
  font-size: 16px;
  line-height: 1.6;
  color: #666;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.feature-item .label,
.scenario-item .label {
  color: #333;
  font-weight: 600;
  white-space: nowrap;
  margin-right: 8px;
}

.feature-item .content,
.scenario-item .content {
  flex: 1;
  white-space: pre-line;
}

.view-details-btn {
  background-color: #30bbfc;
  border-color: #30bbfc;
  padding: 12px 30px;
  font-size: 16px;
  margin-top: 30px;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.view-details-btn:hover {
  background-color: #2596d1;
  border-color: #2596d1;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(48, 187, 252, 0.3);
}
.content-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.text-white {
  transition: all 1s;
  box-shadow: 1px 1px 10px 10px rgba(223, 222, 222, 0.4);
}

.text-white:hover {
  transform: scale(1.1, 1.1);
}

.partners {
  text-align: center;

  h1 {
    font-size: 40px;
    color: #18182a;
  }

  h2 {
    font-size: 18px;
    color: #555;
    margin-top: 20px;
  }

  .partners-icon {
    padding: 60px 0 100px;

    img {
      margin: 10px;
    }
  }
}


/* 多场景解决方案样式 */
.solutions-container {
  display: flex;
  gap: 8px;
  height: 400px;
}

.solution-card {
  position: relative;
  cursor: pointer;
  border-radius: 6px;
  overflow: hidden;
  transition: all 0.3s ease;
  flex: 1;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.solution-card:hover {
  transform: scale(1.05);
}

.solution-card.active {
  flex: 4.5;
  z-index: 2;
}

.solution-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.solution-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.solution-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 20px;
  color: white;
}

.solution-card:not(.active) .solution-content {
  justify-content: flex-end;
}

.solution-card.active .solution-content {
  justify-content:center;
  padding: 40px;
}

.solution-content h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 10px 0;
}

.solution-card.active .solution-content h3 {
  font-size: 30px;
  margin-bottom: 15px;
}
.solution-card.active .solution-content h3::after {
  content: '';
  display: block;
  width: 100px;
  height: 4px;
  background-color: #fff;
  margin-top: 10px;
}

.solution-subtitle {
  font-size: 24px;
  margin: 0 0 15px 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.solution-description {
  font-size: 18px;
  line-height: 1.6;
  margin: 0 0 20px 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.solution-btn {
  align-self: flex-start;
  border: 1px solid white;
  color: white;
  background: transparent;
  padding: 8px 20px;
  font-size: 14px;
}

.solution-btn:hover {
  background: white;
  color: #30bbfc;
  border-color: white;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .solutions-container {
    flex-direction: column;
    height: auto;
  }
  
  .solution-card {
    height: 200px;
    margin-bottom: 20px;
  }
  
  .solution-card.active {
    flex: 1;
    height: 300px;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Index.vue